var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.isSquareMeter ? _c('span', [_vm._v("\n  " + _vm._s(_setup.output) + "/м"), _c('sup', [_vm._v("2")])]) : _c('span', [_vm._v("\n  " + _vm._s(_setup.output) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };